module.exports = __webpack_public_path__ + "img/4-1.7afb4733.png";